import React, { Component } from 'react';

export default class MatchCell extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <td className='match-cell'>
        <span className='col-sm-5 home'>{ this.props.homeTeam }</span>
        <span className='col-sm-2 vs'>vs</span>
        <span className='col-sm-5 away'>{ this.props.awayTeam }</span>
      </td>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/MatchCell.js
 **/